import { mapPaginated } from '@sb/feathers-types';
import { makeNamespacedLog } from '@sb/log';
import { Space } from '@sb/routine-runner';

import { getRoutinesService } from './utils';

const log = makeNamespacedLog('getAllRoutinesWithSpace');

export interface RoutineSpaceSnapshot {
  id: string;
  name: string;
  space: Space.Item[];
}

function parseSpace(rawSpace: unknown): Space.Item[] {
  if (!Array.isArray(rawSpace)) return [];

  const items: Space.Item[] = [];

  for (const rawItem of rawSpace) {
    const migrated = Space.migratePalletBoxesData(rawItem);
    const parsed = Space.Item.safeParse(migrated);

    if (parsed.success) {
      items.push(parsed.data);
    } else {
      log.warn(
        'spaceItem.parse.error',
        'Failed to parse space item while scanning routines; skipping',
        { error: parsed.error },
      );
    }
  }

  return items;
}

export async function getAllRoutinesWithSpace(): Promise<
  RoutineSpaceSnapshot[]
> {
  const response = await getRoutinesService().find({
    query: { $select: ['id', 'name', 'space'] },
  });

  return mapPaginated(response, (data) => ({
    id: data.id,
    name: data.name,
    space: parseSpace((data as { space?: unknown }).space),
  }));
}
